module.exports = __webpack_public_path__ + "img/parnter-3.14df106e.png";